import axios from 'axios';
import { loginStart, loginSuccess, loginFailure } from './AuthActions';

export const login = async (user, dispatch) => {
  dispatch(loginStart());

  try {
    const res = await axios.post(
      `https://ecommerce-api-l3as.onrender.com/api/v1/auth/login`,
      user,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    res.data.data.user.isAdmin && dispatch(loginSuccess(res.data));
    // toast.success('Successfully logged in😎');
  } catch (err) {
    dispatch(loginFailure());
    // toast.error('Incorrect email or password or you are not a admin');
  }
};
